<template>
  <div v-loading="loading">
    <ds-header title="C端运营权限管理"></ds-header>
    <a-form class="search-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-row :gutter="10">
        <a-col :span="4">
          <a-form-item label="姓名：">
            <a-input v-model="searchForm.name" placeholder="请输入姓名"  class="inputClass" />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="手机号：">
            <a-input v-model="searchForm.phone" placeholder="请输入手机号"  class="inputClass" />
          </a-form-item>
        </a-col>
        <!-- <a-col :span="4">
          <a-form-item label="所属租户：">
            <a-select
              mode="multiple"
              v-model="searchForm.tenantId"
              placeholder="请选择租户"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            >
              <a-select-option v-for="option in tenantOpts" :key="option.tenantId" :value="option.tenantId">
                {{ option.tenantName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
        <a-col :span="4">
          <a-form-item label="角色：">
            <a-select v-model="searchForm.roleCode">
              <a-select-option v-for="it in roleOpts" :key="it.value" :value="it.value">{{ it.label }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="状态：">
            <a-select v-model="searchForm.status">
              <a-select-option v-for="it in statusOpts" :key="it.value" :value="it.value">{{ it.label }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="">
            <a-button icon="search" @click="()=>resetSearchForm(false)" type="primary">搜索</a-button>
            <a-button class="left-gap-10" icon="redo" @click="()=>resetSearchForm(true)">重置</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="">
      <a-button 
        v-if="$checkButtonPermissions($buttonPermissionsConfig.clientOperationRoleManage.add)"
        icon="plus" 
        @click="goEditPage()" 
        type="primary">新增</a-button>
    </div>
    <a-table
      :rowKey="(record, index) => record.id"
      :columns="table.columns"
      :data-source="table.dataInfo"
      :pagination="table.pagination.total ? table.pagination : false"
      @change="pageChange"
      style="margin-top: 15px;"
      bordered
    >
      <div slot="action" slot-scope="text, record">
        <a-button @click="goPerviewPage(record)" type="link" size="small">查看</a-button>
        <a-button 
          v-if="$checkButtonPermissions($buttonPermissionsConfig.clientOperationRoleManage.edit)" 
          @click="goEditPage(record)" 
          type="link" 
          size="small">编辑</a-button>
        <a-button 
          v-if="$checkButtonPermissions($buttonPermissionsConfig.clientOperationRoleManage.delete)" 
          @click="deleteRoleOne(record)" 
          type="link" 
          size="small">删除</a-button>
        <a-button 
          v-if="$checkButtonPermissions($buttonPermissionsConfig.clientOperationRoleManage.status)" 
          @click="changeStatus(record)" 
          type="link" 
          size="small">{{record.status === 0 ? "启用" : "禁用"}}</a-button>
      </div>
    </a-table>
    <a-modal
      :title="dynamicDialogTitle"
      :visible="visible"
      @ok="handleOk"
      :maskClosable="false"
      @cancel="visible = false"
    >
      <a-form-model ref="saveForm" :model="editForm" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
        <a-form-model-item label="手机号：" prop="phone">
          <a-input v-model.trim="editForm.phone" :disabled="disabled" :maxLength="11" placeholder="请输入手机号"  class="inputClass" />
        </a-form-model-item>
        <a-form-model-item label="姓名：" prop="name">
          <a-input v-model.trim="editForm.name" :disabled="disabled" :maxLength="10" placeholder="请输入姓名"  class="inputClass" />
        </a-form-model-item>
        <a-form-model-item label="角色：" prop="roleCodes">
          <a-select mode="multiple" v-model="editForm.roleCodes" :disabled="disabled">
            <a-select-option v-for="it in roleOpts" :key="it.value" :value="it.value">{{ it.label }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="项目权限：" prop="projectIds">
          <a-select mode="multiple" v-model="editForm.projectIds" :disabled="disabled">
            <a-select-option v-for="it in projectOpts" :key="it.value" :value="it.value">{{ it.label }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="状态：" prop="status">
          <a-select v-model="editForm.status" :disabled="disabled">
            <a-select-option v-for="it in statusOpts" :key="it.value" :value="it.value">{{ it.label }}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import * as api from "@/api/clientOperation/roleManage.js";
import { getProjectList } from "@/api/home";
import { getLesseeList } from "@/api/authManage/lesseeManage";
export default {
    name: "ClientOperationRoleManage",
    data() {
        return {
          roleId: null,
          isEdit: false,
          visible: false,
          loading: false,
          disabled: false,
          statusOpts: [
            {label: "启用", value: 1},
            {label: "禁用", value: 0},
          ],
          searchForm: {
            name: '',
            phone: '',
            projectIds: '',
            // tenantId: [],
            roleCode: '',
            status: null,
          },
          editForm: {
            id: null,
            phone: '',
            name: '',
            roleCodes: [],
            projectIds: [],
            status: null,
          },
          table: {
            dataInfo: [],
            columns: [
              {
                title: "手机号",
                dataIndex: "phone",
                key: "phone",
              },
              {
                title: "姓名",
                dataIndex: "name",
                key: "name",
              },
              {
                title: "角色",
                dataIndex: "roleNames",
                key: "roleNames",
                customRender: (text) => (text || []).join(",") || "-"
              },
              // {
              //   title: "所属租户",
              //   dataIndex: "tenantName",
              //   key: "tenantName",
              //   customRender: (text) => text || "-"
              // },
              {
                title: "状态",
                dataIndex: "statusName",
                key: "statusName",
                width: "100px",
              },
              {
                title: "更新时间",
                dataIndex: "gmtModified",
                key: "gmtModified",
              },
              {
                title: "操作",
                key: "action",
                className: "action-ql-list",
                scopedSlots: { customRender: "action" },
                width: "220px",
                fixed: 'right',
              },
            ],
            pagination: {
              showSizeChanger: true,
              current: 1,
              pageSize: 10,
              total: 0,
              showQuickJumper: true,
              showTotal: (total) => {
                return `共 ${total} 条`;
              },
            },
          },
          projectOpts: [],
          roleOpts: [],
          tenantOpts: [],
          rules: {
            phone: [
              { required: true, message: "请输入手机号", trigger: "blur" }
            ],
            name: [
              { required: true, message: "请输入姓名", trigger: "blur" }
            ],
            roleCodes: [
              { required: true,
                validator: (rule, value, callback) => {
                if(value.length === 0){
                  callback(new Error("请选择角色"));
                }else{
                  callback();
                }
              }, trigger: "change" }
            ],
            projectIds: [
              { required: true,
                validator: (rule, value, callback) => {
                if(value.length === 0){
                  callback(new Error("请选择项目权限"));
                }else{
                  callback();
                }
              }, trigger: "change" }
            ],
            status: [
              { required: true, message: "请选择状态", trigger: "change" }
            ]
          }
        }
    },
    computed: {
      dynamicDialogTitle(){
        if(this.disabled) return "查看账户";
        return `${this.isEdit ? '编辑' : '新增'}账户`;
      }
    },
    created(){
      this.roleId = this.$route.meta.roleId;
    },
    mounted(){
        this.getList();
        this.getRoleList();
        this.getProjectList();
        this.getLessee();
    },
    methods: {
      //获取租户列表
      async getLessee() {
        try {
          const searchForm = {
            userName: "",
            tenantName: "",
          };
          const result = await getLesseeList(searchForm, 1, 9999);
          this.tenantOpts = result.data.list;
        } catch (error) {}
      },
      getRoleList(){
        return api.getRoleOptions().then(({code, data}) => {
          if(code === '200'){
            this.roleOpts = (data || []).map((it)=> ({label: it.roleName, value: it.roleCode}))
          }
        })
      },
      getProjectList() {
        return getProjectList({roleId: this.roleId}).then(({code, data}) => {
          if (code === '200') {
            const projects = data || [];
            const list = [];
            for (const it of projects) {
              list.push(it);
              if(it.child && it.child.length){
                list.push(...it.child);
              }
            }
            this.projectOpts = list.map(it => ({label: it.project_name, value: it.id}));
          }
        });
      },
      handleOk(){
        if(this.disabled){
          this.visible = false;
          return;
        }
        this.$refs["saveForm"].validate((valid) => {
          if (valid) {
            this.saveForm();
          }else{
            console.log("校验未通过");
          }
        });
      },
      saveForm(){
        const params = {
          ...this.editForm
        }
        if(!this.isEdit){
          delete params.id;
        }
        this.loading = true;
        const promise = this.isEdit ? api.updateAccount(params) : api.addAccount(params);
        promise
          .finally(() => {
            this.loading = false;
          })
          .then(({code, msg}) => {
            if(code === '200'){
              this.$message.success(msg);
              this.visible = false;
              this.resetSearchForm();
            }else{
              this.$message.error(msg);
            }
          });
      },
      filterSearchForm(){
        const copyForm = {...this.searchForm};
        for (const attr in copyForm) {
          const it = copyForm[attr];
          if(it === "" || it === null || Array.isArray(it) && !it.length){
            delete copyForm[attr];
          }
        }
        for (const attr in copyForm) {
          const it = copyForm[attr];
          if(Array.isArray(it) && it.length){
            copyForm[attr] = it.join(",");
          }
        }
        return copyForm;
      },
      resetSearchForm(resetForm = false){
        if(resetForm){
          this.searchForm = this.$options.data.call(this).searchForm;
        }
        this.pageChange({current: 1,pageSize: 10});
      },
      goPerviewPage(record){
        this.visible = true;
        this.visible = true;
        this.disabled = true;
        this.editForm = {
          phone: record.phone,
          name: record.name,
          roleCodes: record.roleCodes,
          projectIds: record.projectIds,
          status: record.status,
        }
      },
      goEditPage(record){
        this.isEdit = record ? true : false;
        this.visible = true;
        this.disabled = false;
        this.$nextTick(()=>{
          this.$refs["saveForm"].clearValidate();
        });
        if(record){
          this.loading = true;
          api.getAccountDetail({id: record.id})
            .finally(() => {
              this.loading = false;
            })
            .then(({code, data}) => {
              if(code === '200'){
                this.editForm = {
                  id: data.id,
                  phone: data.phone,
                  name: data.name,
                  roleCodes: data.roleCodes,
                  projectIds: data.projectIds,
                  status: data.status,
                }
              }
            });
        }else{
          this.editForm = this.$options.data.call(this).editForm;
        }
      },
      deleteRoleOne(record){
        this.$confirm({
          title: "提示",
          content: "是否确定删除用户在i友上的运营端权限？",
          okText: "是",
          cancelText: "否",
          onOk: () => {
            this.loading = true;
            api.deleteAccount({id: record.id})
              .finally(() => {
                this.loading = false;
              })
              .then(({code, msg}) => {
                if(code === '200'){
                  this.$message.success(msg);
                  this.resetSearchForm();
                }else{
                  this.$message.error(msg);
                }
              });
          },
          onCancel(){
            console.log("关闭");
          }
        });
      },
      changeStatus(record){
        this.$confirm({
          title: "提示",
          content: `是否确定${record.status === 1 ? "禁用" : "启用"}用户在i友上的运营端权限？`,
          okText: "是",
          cancelText: "否",
          onOk: () => {
            this.loading = true;
            const newStatus = record.status === 1 ? 0 : 1;
            api.changeStatus({id: record.id, status: newStatus})
            .finally(() => {
                this.loading = false;
              })
              .then(({code, msg}) => {
                if(code === '200'){
                  this.$message.success(msg);
                  this.resetSearchForm();
                }else{
                  this.$message.error(msg);
                }
              });
          },
          onCancel(){
            console.log("关闭");
          }
        });
      },
      pageChange(option){
        this.table.pagination.current = option.current;
        this.table.pagination.pageSize = option.pageSize;
        this.getList();
      },
      getList(){
        const params = {
          page: this.table.pagination.current, 
          pageSize: this.table.pagination.pageSize,
          ...this.filterSearchForm()
        };
        this.loading = true;
        return api.getAccountList(params)
        .finally(() => {
          this.loading = false;
        })
        .then(({code, data, msg}) => {
          if(code == '200'){
            this.table.dataInfo = data.items;
            this.table.pagination.total = data.total;
          }else{
            this.$message.error(msg);
          }
        });
      }
    }
}
</script>
<style lang="scss" scoped>
  .left-gap-10{
    margin-left: 10px;
  }
  ::v-deep .search-form .ant-form-item{
    margin-bottom: 10px !important;
  }
</style>